module.exports = __webpack_public_path__ + "img/4.dd58724e.jpeg";